<template>
    <div>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="'bottom'"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div
            class="appHeader bg-primary text-light curved-header"
            style="--height-curved: 180px"
        >
            <div class="pageTitle left">
                <img
                    :src="require('@/assets/image/logo_header_white.png')"
                    alt="logo"
                    class="logo"
                />
            </div>
            <div class="right" id="contact">
                <router-link :to="{ name: 'care-center' }" class="headerButton">
                    <div>
                        <p
                            style="
                                font-size: 10px;
                                line-height: 1.5;
                                margin: 0;
                                width: 60px;
                                text-align: right;
                            "
                        >
                            Hubungi<br />Kami
                        </p>
                    </div>
                    <ion-icon
                        class="icon ml-1"
                        name="chatbox-ellipses"
                    ></ion-icon>
                </router-link>
            </div>
            <div
                class="section wallet-card-section w-100"
                style="margin-top: 90px"
            >
                <div class="wallet-card">
                    <div
                        class="balance"
                        style="margin-bottom: 5px"
                        id="info_balance"
                    >
                        <div class="col-6 text-left pl-0">
                            <span class="title">Saldo</span>
                            <h1
                                class="total"
                                :class="{
                                    'loading-component': loading.content,
                                }"
                            >
                                <span>Rp {{ customer.balance | rupiah }}</span>
                            </h1>
                        </div>
                        <div class="col-6 text-right pr-0">
                            <span class="title">Points</span>
                            <h1
                                class="total"
                                :class="{
                                    'loading-component': loading.content,
                                }"
                            >
                                <span>{{ points | rupiah }}</span>
                            </h1>
                        </div>
                    </div>
                    <div class="wallet-footer">
                        <div class="item" id="balance">
                            <a href="Javascript:;" @click="showOptionBalance()">
                                <img
                                    v-lazyload
                                    :src="require('@/assets/Loader-2.png')"
                                    :data-src="
                                        require('@/assets/icon_menu/saldo.png')
                                    "
                                    alt="image"
                                    class="icon-wrapper"
                                    style="
                                        border-radius: 0;
                                        background-color: transparent;
                                    "
                                />
                                <strong>Saldo</strong>
                            </a>
                        </div>
                        <div class="item" id="points">
                            <router-link :to="{ name: 'points' }">
                                <img
                                    v-lazyload
                                    :src="require('@/assets/Loader-2.png')"
                                    :data-src="
                                        require('@/assets/icon_menu/poin.png')
                                    "
                                    alt="image"
                                    class="icon-wrapper"
                                    style="
                                        border-radius: 0;
                                        background-color: transparent;
                                    "
                                />
                                <strong>Points</strong>
                            </router-link>
                        </div>
                        <!-- <div class="item" id="donasi">
                            <router-link :to="{ name: 'donasi' }">
                                <img
                                    v-lazyload
                                    :src="require('@/assets/Loader-2.png')"
                                    :data-src="
                                        require('@/assets/icon_menu/donasi.png')
                                    "
                                    alt="image"
                                    class="icon-wrapper"
                                    style="
                                        border-radius: 0;
                                        background-color: transparent;
                                    "
                                />
                                <strong>Donasi</strong>
                            </router-link>
                        </div> -->
                        <div class="item" id="qris">
                            <router-link :to="{ name: 'qris' }">
                                <img
                                    v-lazyload
                                    :src="require('@/assets/Loader-2.png')"
                                    :data-src="
                                        require('@/assets/icon_menu/qris_new.png')
                                    "
                                    alt="image"
                                    class="icon-wrapper"
                                    style="
                                        border-radius: 0;
                                        background-color: transparent;
                                    "
                                />
                                <strong>QRIS</strong>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="appCapsule" style="padding-top: 45px">
            <!-- Verifikasi  -->
            <div
                class="section inset mb-2"
                v-if="
                    !customer.account_verified_data ||
                    customer.account_verified_data.status != 'APPROVED'
                "
            >
                <div class="wide-block p-2 text-center">
                    <h4>Buka Semua Fitur Unggulan</h4>
                    <small
                        >Verifikasi akunmu untuk transfer tanpa batas dan
                        nikmati semua keuntungannya.</small
                    >
                    <div>
                        <router-link
                            :to="{ name: 'account.data-diri' }"
                            class="btn btn-primary mt-1"
                            style="text-decoration: none"
                            ><span style="color: white"
                                >Verifikasi Sekarang</span
                            ></router-link
                        >
                    </div>
                </div>
            </div>

            <div id="product">
                <!-- Produk Pembelian -->
                <div
                    class="section order-menu-utama clearfix"
                    style="margin-bottom: 10px"
                    v-if="categoryUtama.length > 0"
                >
                    <div class="section-heading mb-2">
                        <h2 class="title" style="font-size: 15px">
                            Fitur Lainnya
                        </h2>
                    </div>
                    <div class="menu">
                        <!-- PRODUK SPESIAL -->
                        <div
                            class="item"
                            v-for="item in groupProductSpecial"
                            :key="'product-special-' + item.id"
                            style="flex: none"
                        >
                            <router-link
                                :to="{
                                    name: 'prabayar-special-product',
                                    params: {
                                        id: item.id,
                                        title: item.product_name,
                                        withPrefix: 0,
                                    },
                                }"
                            >
                                <img
                                    v-lazyload
                                    :src="require('@/assets/Loader-2.png')"
                                    :data-src="
                                        item.icon
                                            ? VUE_ENV.VUE_APP_ASSET_URL +
                                              '/img/icon/' +
                                              item.icon
                                            : require('@/assets/Loader-2.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong
                                    ><span>{{ item.group_name }}</span></strong
                                >
                            </router-link>
                        </div>
                        <!-- PRODUCT PRABAYAR -->
                        <div
                            class="item"
                            v-for="item in categoryUtama"
                            :key="item.id"
                            style="flex: none"
                        >
                            <!-- With Prefix  -->
                            <router-link
                                :to="{
                                    name: 'prabayar-with-prefix-product',
                                    params: {
                                        id: item.id,
                                        title: item.product_name,
                                        withPrefix: item.withPrefix,
                                    },
                                }"
                                v-if="item.withPrefix === 1"
                            >
                                <img
                                    v-lazyload
                                    :src="require('@/assets/Loader-2.png')"
                                    :data-src="
                                        item.icon
                                            ? VUE_ENV.VUE_APP_ASSET_URL +
                                              '/img/icon/' +
                                              item.icon
                                            : require('@/assets/Loader-2.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong
                                    :class="
                                        item.product_name == 'Loading...'
                                            ? 'loading-component'
                                            : ''
                                    "
                                    ><span>{{
                                        item.product_name
                                    }}</span></strong
                                >
                            </router-link>

                            <!-- Without Prefix -->
                            <router-link
                                :to="{
                                    name: 'prabayar-without-prefix-product',
                                    params: {
                                        id: item.id,
                                        title: item.product_name,
                                        withPrefix: item.withPrefix,
                                        styleProduct: item.style_product,
                                    },
                                }"
                                v-else
                            >
                                <img
                                    v-lazyload
                                    :src="require('@/assets/Loader-2.png')"
                                    :data-src="
                                        item.icon
                                            ? VUE_ENV.VUE_APP_ASSET_URL +
                                              '/img/icon/' +
                                              item.icon
                                            : require('@/assets/Loader-2.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong
                                    :class="
                                        item.product_name == 'Loading...'
                                            ? 'loading-component'
                                            : ''
                                    "
                                    ><span>{{
                                        item.product_name
                                    }}</span></strong
                                >
                            </router-link>
                        </div>

                        <!-- PRODUK LAINNYA -->
                        <div class="item" style="flex: none" id="product_other">
                            <router-link :to="{ name: 'other' }">
                                <img
                                    :src="
                                        require('@/assets/icon_menu/other.png')
                                    "
                                    alt="image"
                                    class="imaged"
                                    style="width: 60%"
                                />
                                <strong style="margin: 3px; font-size: 10px"
                                    >Lainnya</strong
                                >
                                <!-- </a> -->
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <!-- * Banner Informasi & Promo -->
            <div class="section full mb-2">
                <div v-if="banner.length > 0">
                    <carousel
                        :autoplay="true"
                        :nav="false"
                        :dots="true"
                        :loop="true"
                        :items="1"
                        :stagePadding="30"
                        :margin="15"
                    >
                        <img
                            v-for="item in banner"
                            :key="item.index"
                            :src="
                                VUE_ENV.VUE_APP_ASSET_URL +
                                '/img/banner/' +
                                item.banner
                            "
                            class="imaged"
                            :alt="item.title"
                            @click="showInformation(item.information_id)"
                        />
                    </carousel>
                </div>
            </div>
        </div>

        <!-- Menampilkan Produk Lainnya -->
        <action-sheet
            ref="product"
            :title="'Pilih Produk'"
            :inset="false"
            :content-full="true"
        >
            <ul class="listview image-listview">
                <li v-for="item in categoryPrabayar" :key="'PRA-' + item.id">
                    <a
                        style="cursor: pointer"
                        class="item"
                        @click="selectProduct('PRABAYAR', item)"
                    >
                        <img
                            v-lazyload
                            :src="require('@/assets/Loader-2.png')"
                            :data-src="
                                item.icon
                                    ? VUE_ENV.VUE_APP_ASSET_URL +
                                      '/img/icon/' +
                                      item.icon
                                    : require('@/assets/Loader-2.png')
                            "
                            alt="image"
                            class="image"
                        />
                        <div class="in">
                            <div>{{ item.product_name }}</div>
                        </div>
                    </a>
                </li>
                <li
                    v-for="item in categoryPascabayar"
                    :key="'PASCA-' + item.id"
                >
                    <a
                        style="cursor: pointer"
                        class="item"
                        @click="selectProduct('PASCABAYAR', item)"
                    >
                        <img
                            v-lazyload
                            :src="require('@/assets/Loader-2.png')"
                            :data-src="
                                item.icon
                                    ? VUE_ENV.VUE_APP_ASSET_URL +
                                      '/img/icon/' +
                                      item.icon
                                    : require('@/assets/Loader-2.png')
                            "
                            alt="image"
                            class="image"
                        />
                        <div class="in">
                            <div>{{ item.product_name }}</div>
                        </div>
                    </a>
                </li>
            </ul>
        </action-sheet>

        <!-- Information Verification -->
        <action-sheet
            ref="information_verification"
            :title="'Informasi'"
            :inset="false"
        >
            <div class="text-center">
                <img
                    :src="require('@/assets/verification_rejected.png')"
                    alt="Verifikasi dalam proses"
                    class="w-50"
                /><br />
            </div>
            <div class="text-center p-2">
                <h3 class="mb-0">Anda belum melengkapi data diri</h3>
                <p class="mb-0">Yuk, segera langkapi sekarang</p>
            </div>
            <div class="form-group basic">
                <button
                    class="btn btn-primary btn-block"
                    @click="hideInformationVerification(true)"
                >
                    Lengkapi Data Diri
                </button>
                <button
                    class="btn btn-outline-primary btn-block"
                    @click="hideInformationVerification(false)"
                >
                    Kembali
                </button>
            </div>
        </action-sheet>

        <!-- Option Transfer -->
        <action-sheet
            ref="option_transfer"
            :title="'Pilih Jenis Transfer'"
            :inset="false"
            :content-full="true"
        >
            <ul class="listview image-listview">
                <li>
                    <a
                        style="cursor: pointer"
                        class="item"
                        @click="selectOptionTransfer('sendmoney.order')"
                    >
                        <img
                            v-lazyload
                            :src="require('@/assets/Loader-2.png')"
                            :data-src="
                                require('@/assets/icon_menu/icon_transfer_bank.png')
                            "
                            alt="image"
                            class="image"
                        />
                        <div class="in">
                            <div>
                                <strong>Transfer ke Rekening</strong>
                                <footer>
                                    Transfer ke rekening bank dengan biaya admin
                                    rendah
                                </footer>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        style="cursor: pointer"
                        class="item"
                        @click="selectOptionTransfer('transfer')"
                    >
                        <img
                            v-lazyload
                            :src="require('@/assets/Loader-2.png')"
                            :data-src="
                                require('@/assets/icon_menu/icon_transfer_sesama.png')
                            "
                            alt="image"
                            class="image"
                        />
                        <div class="in">
                            <div>
                                <strong>Transfer ke Sesama</strong>
                                <footer>
                                    Transfer saldo ke sesama pengguna
                                    {{ VUE_ENV.VUE_APP_NAME }}
                                    tanpa biaya
                                </footer>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </action-sheet>

        <!-- Option Saldo -->
        <action-sheet
            ref="option_balance"
            :title="'Pilihan'"
            :inset="false"
            :content-full="true"
        >
            <ul class="listview image-listview">
                <li>
                    <a
                        style="cursor: pointer"
                        class="item"
                        @click="selectOptionBalance('deposit')"
                    >
                        <img
                            v-lazyload
                            :src="require('@/assets/Loader-2.png')"
                            :data-src="
                                require('@/assets/icon_menu/deposit.png')
                            "
                            alt="image"
                            class="image"
                        />
                        <div class="in">
                            <div>
                                <strong>Deposit Saldo</strong>
                                <footer>
                                    Tambah saldo utama dengan berbagai pilihan
                                    pembayaran
                                </footer>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        style="cursor: pointer"
                        class="item"
                        @click="selectOptionBalance('mutasi')"
                    >
                        <img
                            v-lazyload
                            :src="require('@/assets/Loader-2.png')"
                            :data-src="require('@/assets/icon_menu/mutasi.png')"
                            alt="image"
                            class="image"
                        />
                        <div class="in">
                            <div>
                                <strong>Mutasi Saldo</strong>
                                <footer>
                                    Pantau aktifitas saldo lebih mudah
                                </footer>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        style="cursor: pointer"
                        class="item"
                        @click="selectOptionBalance('transfer')"
                    >
                        <img
                            v-lazyload
                            :src="require('@/assets/Loader-2.png')"
                            :data-src="
                                require('@/assets/icon_menu/icon_transfer_sesama.png')
                            "
                            alt="image"
                            class="image"
                        />
                        <div class="in">
                            <div>
                                <strong>Transfer Saldo</strong>
                                <footer>
                                    Transfer saldo ke sesama pengguna
                                    {{ VUE_ENV.VUE_APP_NAME }}
                                    tanpa biaya
                                </footer>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </action-sheet>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import carousel from 'vue-owl-carousel';
    import $axios from './../api.js';
    export default {
        name: 'Beranda',
        components: { carousel },
        data: () => ({
            points: '0',
            countCategoryPrabayar: 14,
            loading: {
                content: true,
            },
            gamefav: [
                {
                    id: 97,
                    product_name: 'Free Fire Termurah',
                    description: null,
                    image: 'FF.jpg',
                    icon: '',
                },
                {
                    id: 117,
                    product_name: 'Mobile Legends Termurah',
                    description: null,
                    image: 'ML.jpg',
                    icon: '',
                },
                {
                    id: 71,
                    product_name: 'PUBG Mobile Termurah',
                    description: null,
                    image: 'PUBGM.jpg',
                    icon: '',
                },
                {
                    id: 120,
                    product_name: 'Higgs Domino Termurah',
                    description: null,
                    image: 'HD.jpg',
                    icon: '',
                },
            ],
            kaezenCategorySpesial: [
                {
                    id: 1,
                    icon: '/assets/icon_menu/kaezen_menu_product/promo.png',
                    name: 'Promo Mingguan',
                },
            ],
            kaezenCategory: [
                {
                    id: 1,
                    icon: '/assets/icon_menu/kaezen_menu_product/pulsa.png',
                    name: 'Pulsa',
                },
                {
                    id: 2,
                    icon: '/assets/icon_menu/kaezen_menu_product/paket_data.png',
                    name: 'Paket Data',
                },
                {
                    id: 3,
                    icon: '/assets/icon_menu/kaezen_menu_product/paket_telp_sms.png',
                    name: 'Paket Telpon & SMS',
                },
            ],
        }),
        computed: {
            ...mapState([
                'setting',
                'customer',
                'groupProductSpecial',
                'categoryPrabayar',
                'categoryPascabayar',
                'banner',
                'VUE_ENV',
                'toast',
            ]),
            // chunkCategoryUtama() {
            //     return window._.chunk(
            //         window._.toArray(this.categoryPrabayar.slice(0, 11)),
            //         4
            //     );
            // },
            categoryUtama() {
                let countCategoryPrabayar = 11;
                if (this.groupProductSpecial.length > 0) {
                    countCategoryPrabayar =
                        countCategoryPrabayar - this.groupProductSpecial.length;
                }
                return window._.toArray(
                    this.categoryPrabayar.slice(0, countCategoryPrabayar),
                );
            },
        },
        methods: {
            ...mapActions([
                'getGroupProductSpecial',
                'getCategoryPrabayar',
                'getCategoryPascabayar',
                'getCategoryPascabayar',
                'getBanner',
                'getCustomer',
                'getSetting',
                'coming',
            ]),
            checkAccountVerification() {
                if (
                    this.customer.account_verified_data == null ||
                    this.customer.account_verified_data.status != 'APPROVED'
                ) {
                    return true;
                } else {
                    return false;
                }
            },
            selectMenuSendMoney(title, transfer_method_selected) {
                if (this.checkAccountVerification()) {
                    this.showInformationVerification();
                } else {
                    this.$router.push({
                        name: 'sendmoney.order',
                        params: {
                            title: title,
                            transfer_method_selected: transfer_method_selected,
                        },
                    });
                }
            },
            selectOptionBalance(routeName) {
                this.hideOptionBalance();
                if (
                    !['deposit', 'mutasi'].includes(routeName) &&
                    this.checkAccountVerification()
                ) {
                    this.showInformationVerification();
                } else {
                    this.$router.push({ name: routeName });
                }
            },
            showOptionBalance() {
                let element = this.$refs.option_balance.$el;
                window.$(element).modal('show');
            },
            hideOptionBalance() {
                let element = this.$refs.option_balance.$el;
                window.$(element).modal('hide');
            },
            showOptionTransfer() {
                let element = this.$refs.option_transfer.$el;
                window.$(element).modal('show');
            },
            hideOptionTransfer() {
                let element = this.$refs.option_transfer.$el;
                window.$(element).modal('hide');
            },
            showInformation(information_id) {
                if (information_id != null) {
                    this.$router.push({
                        name: 'info.index',
                        params: { information_id: information_id },
                    });
                }
            },
            modalProduct(value) {
                if (this.$refs.product != undefined) {
                    let element = this.$refs.product.$el;
                    window.$(element).modal(value);
                }
            },
            selectProduct(type, data) {
                this.modalProduct('hide');
                if (type === 'PRABAYAR') {
                    if (data.withPrefix === 1) {
                        this.$router.push({
                            name: 'order-prabayar',
                            params: {
                                id: data.id,
                                title: data.product_name,
                                withPrefix: data.withPrefix,
                            },
                        });
                    } else {
                        this.$router.push({
                            name: 'product-prabayar',
                            params: {
                                id: data.id,
                                title: data.product_name,
                                withPrefix: data.withPrefix,
                                styleProduct: data.style_product,
                            },
                        });
                    }
                } else {
                    this.$router.push({
                        name: 'pascabayar',
                        params: { id: data.id, title: data.product_name },
                    });
                }
            },
            showInformationVerification() {
                let element = this.$refs.information_verification.$el;
                window.$(element).modal('show');
            },
            hideInformationVerification(redirect) {
                let element = this.$refs.information_verification.$el;
                window.$(element).modal('hide');
                if (redirect) {
                    this.$router.push({ name: 'account.data-diri' });
                }
            },
            selectOptionTransfer(routeName) {
                this.hideOptionTransfer();
                this.$router.push({ name: routeName });
            },
            getTotalPoints() {
                $axios.get('/points/total').then(response => {
                    this.points = response.data.data.points;
                });
            },
        },
        mounted() {
            this.getTotalPoints();
            this.getCustomer()
                .then(() => {
                    this.loading.content = false;
                })
                .catch(() => {
                    this.loading.content = false;
                });
            this.getBanner();
            this.getGroupProductSpecial();
            if (this.categoryPrabayar[0].product_name === 'Loading...') {
                this.getCategoryPrabayar();
                this.getCategoryPascabayar();
            }

            if (Object.keys(this.setting).length == 0) {
                this.getSetting();
            }
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
